import { Component, TemplateRef, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, AfterViewInit, Renderer2, ChangeDetectorRef } from '@angular/core';
import { OrderService } from '@app/cp/shared/services/order.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { Subscription } from 'rxjs';
import { SelectionEvent, ColumnComponent } from '@progress/kendo-angular-grid';
import { OrderDetailsBus } from '@app/cp/shared/models/OrderDetailsBus';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { LineItemsSummary } from '@app/cp/shared/models/LineItemsSummary';
import { MessageType } from '@app/cp/shared/enums/MessageType';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { v_InventoryBus } from '@app/cp/shared/models/v_InventoryBus';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { InventorySuppliersBus } from '@app/cp/shared/models/InventorySuppliersBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'return-parts',
    templateUrl: './return-parts.component.html',
    styleUrls: ['./return-parts.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class VendorReturnPartsComponentX extends BaseGridEditLineComponent<OrderDetailsBus, null, OrderService>  {

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: OrderService, svc_inv: InventoryService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;

        this.className = "OrderDetailsBus";
  }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'orderDetailId': new UntypedFormControl(),
            'inventoryId': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'inventoryNumber': new UntypedFormControl(), //Part #
            'manufacturerNumber': new UntypedFormControl(), //Mfg #
            'inventoryDesc': new UntypedFormControl(), //Description
            'ratio': new UntypedFormControl(), //Ratio
            'quantityReceived': new UntypedFormControl(), //Rcvd
            'quantity': new UntypedFormControl(), //Qty
            'usedPartQuantity': new UntypedFormControl(), //Used Qty
            'quantityBilled': new UntypedFormControl(), //Qty Billed
            'price': new UntypedFormControl(), //Price
            'amount': new UntypedFormControl(), //Amount
            'warehouseId': new UntypedFormControl(), //Intended Warehouse
            'dispatchNumber': new UntypedFormControl(), //Dispatch
            'accountClassId': new UntypedFormControl(), //Class
            'acknowledged': new UntypedFormControl(), //Acknowledged
            'isWrongPart': new UntypedFormControl(), //Wrong Part
            'replace': new UntypedFormControl(), //Replace
            'toBeReturned': new UntypedFormControl(), //To Be Returned
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl()
        });

    }
    setForm() {
        this.editForm.patchValue({
            orderDetailId: this.selectedData.orderDetailId,
            inventoryId: this.selectedData.inventoryId,
            dispatchId: this.selectedData.dispatchId,
            inventoryNumber: this.selectedData.inventoryNumber,
            manufacturerNumber: this.selectedData.manufacturerNumber,
            inventoryDesc: this.selectedData.inventoryDesc,
            ratio: this.selectedData.ratio,
            quantityReceived: this.selectedData.quantityReceived,
            quantity: this.selectedData.quantity,
            usedPartQuantity: this.selectedData.usedPartQuantity,
            quantityBilled: this.selectedData.quantityBilled,
            price: this.selectedData.price,
            amount: this.selectedData.amount,
            warehouseId: this.selectedData.warehouseId,
            dispatchNumber: this.selectedData.dispatchNumber,
            accountClassId: this.selectedData.accountClassId,
            acknowledged: this.selectedData.acknowledged,
            isWrongPart: this.selectedData.isWrongPart,
            replace: this.selectedData.replace,
            toBeReturned: this.selectedData.toBeReturned,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
        });
    }
    protected save(dataObj: OrderDetailsBus) {

        let busObj: OrderDetailsBus = new OrderDetailsBus(dataObj);
    }
    costChange(event, dataItem, editForm) {

    }
    muChange(event, dataItem: OrderDetailsBus, editForm) {
        let mu = (event * 1) / 100;
    }
    delete(data: OrderDetailsBus) {
    }
    protected removeLocal(data: OrderDetailsBus) {
        let index = this.gridData.findIndex(s => s.orderDetailId === data.orderDetailId);
        if (index > 0) {
            this.gridData.splice(index, 1);
        }
    }
    public accountClass(id: string) {
        return this.referenceData.accountClasses.find(x => x.value === id);
    }
    partSuppliers: InventorySuppliersBus[];
    partSuppliersActive: boolean = false;
    partSuppliersHeight: number = 0;
    showInventorySuppliers(dataItem: OrderDetailsBus) {
        this.svc_inv.getInventorySuppliers(dataItem.inventoryId).subscribe((data: InventorySuppliersBus[]) => {
            if (CommonFunctions.hasArrayValue(data)) {
                if (data.length > 20) {
                    this.partSuppliersHeight = 600;
                }
                else {
                    this.partSuppliersHeight = 0;
                }
            }
            this.partSuppliers = data;
            this.partSuppliersActive = true;
        });
    }
    closePartSupplier() {
        this.partSuppliersActive = false;
    }

}
